import AutoSuggestModel from "@Features/autosuggest/models/AutoSuggestModel";
import {fetchSuggestions} from "@Form/functions/fetchSuggestions";
import stripTags from "@Form/functions/stripTags";
import {useState} from "react";
import ajaxHandler from "@Ajax/v2/ajaxHandler";
import useHandleError from "@Errors/hooks/useHandleError";

export default function useStationLocatorAutoSuggest() {
    const [selection, setSelection] = useState('')
    const {setError} = useHandleError()

    const suggestionClickHandler = async (input) => {
        setSelection(stripTags(input?.label))

        try {
            const {data} = await ajaxHandler({
                url: '/ajax/get-station-url',
                params: {
                    stationSlug: input.slug,
                    stationId: input.value,
                },
            })
            document.location.href = data
        } catch (error) {
            setError(error)
        }
    }

    return new AutoSuggestModel({
        suggestionLengthFetchLimit: 2,
        suggestionsHandler: fetchSuggestions,
        suggestionClickHandler,
        inputHandler: (input) => (stripTags(input)),
        clearHandler: () => setSelection(''),
        selection,
    })
}